function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0-2h130v130H0z",
  fill: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 65,
  cy: 63,
  r: 56
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  "data-name": "b",
  cx: 65,
  cy: 63,
  r: 56,
  fill: "#fff",
  stroke: "#12123b",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29 27h72v72H29z",
  fill: "none"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M85 86.51a3.41 3.41 0 01-2.47-1l-18-17.95a3.5 3.5 0 01-1-2.48 3.5 3.5 0 016-2.47l18 18a3.43 3.43 0 011 2.47 3.48 3.48 0 01-3.5 3.5",
  fill: "#fff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M85.84 76.16H44.16a4.38 4.38 0 01-4.38-4.39V42.16a4.38 4.38 0 014.38-4.38h41.68a4.38 4.38 0 014.38 4.38v29.61a4.38 4.38 0 01-4.38 4.39z",
  fill: "#cea656"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M83.64 71.77H46.36a2.2 2.2 0 01-2.2-2.19V44.36a2.21 2.21 0 012.2-2.2h37.28a2.21 2.21 0 012.2 2.2v25.22a2.2 2.2 0 01-2.2 2.19z",
  fill: "#697900"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.29 80.55v7.67H48.55v-7.67a9.86 9.86 0 019.87-9.87 9.86 9.86 0 019.87 9.87z",
  fill: "#ff5200"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.29 80.55v7.67H48.55v-5.48h4.39a7.67 7.67 0 007.67-7.68 9.75 9.75 0 00-1-4.31 9.86 9.86 0 018.68 9.8z",
  fill: "#c00"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M62.26 69.44v1.78a3.84 3.84 0 01-3.84 3.84 3.84 3.84 0 01-3.84-3.84v-1.78a6.58 6.58 0 117.68 0z",
  fill: "#ce7f49"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.24 64.1A6.59 6.59 0 0154 68.48h-.53a6.57 6.57 0 014.92-10.94h.28A6.59 6.59 0 0165 64.1z",
  fill: "#ffc02c"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.55 61.9a4.38 4.38 0 014.39-4.38h5.26v2.19a4.39 4.39 0 01-4.39 4.39h-5.26z",
  fill: "#ffe52c"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.74 80.55v7.67H65v-7.67a9.86 9.86 0 019.87-9.87 9.86 9.86 0 019.87 9.87z",
  fill: "#28749e"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75.14 47.65a.82.82 0 01-.82.82H55.68a.82.82 0 010-1.64h18.64a.81.81 0 01.82.82zm-4.6 3.56h-7.68a.83.83 0 000 1.65h7.68a.83.83 0 000-1.65zm-11 0h-.11a.83.83 0 000 1.65h.11a.83.83 0 000-1.65z",
  fill: "#e7ede2"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.74 80.55v7.67H65v-5.48h4.39a7.67 7.67 0 007.67-7.68 9.75 9.75 0 00-1-4.31 9.86 9.86 0 018.68 9.8z",
  fill: "#2c4d67"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.71 69.44v1.78a3.84 3.84 0 01-3.84 3.84A3.84 3.84 0 0171 71.22v-1.78a6.58 6.58 0 117.68 0z",
  fill: "#ce7f49"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M81.45 64.1H68.29a6.58 6.58 0 0113.16 0z",
  fill: "#602812"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M74.87 57.52h.54a6.58 6.58 0 01-4.93 10.94h-.53a6.57 6.57 0 014.92-10.94z",
  fill: "#823e20"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M88.58 87.4a.83.83 0 01-.83.82H43.89a.82.82 0 010-1.64h43.86a.83.83 0 01.83.82zm-47.87-.82h-.11a.82.82 0 100 1.64h.11a.82.82 0 100-1.64z",
  fill: "#183244"
});

var SvgIc150Lessons = function SvgIc150Lessons(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

export default "data:image/svg+xml;base64,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";
export { SvgIc150Lessons as ReactComponent };